import React from 'react';

const EditIcon = ({ size = '16', fill = '#CE181E', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.16667 13.8332H3.33333L10.5208 6.64567L9.35417 5.479L2.16667 12.6665V13.8332ZM14.0833 5.43734L10.5417 1.93734L11.7083 0.770671C12.0278 0.451226 12.4201 0.291504 12.8854 0.291504C13.3507 0.291504 13.7431 0.451226 14.0625 0.770671L15.2292 1.93734C15.5486 2.25678 15.7153 2.6422 15.7292 3.09359C15.7431 3.54498 15.5903 3.93039 15.2708 4.24984L14.0833 5.43734ZM12.875 6.6665L4.04167 15.4998H0.5V11.9582L9.33333 3.12484L12.875 6.6665Z"
        fill={fill}
      />
    </svg>
  );
};

export default EditIcon;
